var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Pagination from "../../common/components/Pagination";
import { Loading } from 'element-ui';
import { mapGetters } from "vuex";
import PurSortingService from "../../api/PurSortingService";
import PrintConfigService from "../../api/PrintConfigService";
import CommonService from "../../api/CommonService";
import HomeService from "../../api/HomeService";
import GlobalVue from "../../globalVue";
import Add from "./Add.vue";
import { EBillType } from "../../enum/EBillType";
import { UrlHelper } from "../../helper/UrlWrapper";
import { billDefaultDate } from "../../helper/defaultDate";
import _ from 'lodash';
import { EPurSortingStatus } from "../../enum/EStatus";
import { EExportTemplateType } from "../../enum/EExportTemplateType";
import AreaShop from "@/components/AreaShop";
import { toDetail } from '../../helper/util';
import ExportResult from './components/ExportResult.vue';
import PrintSort from '../deliver/PrintSort.vue';
import TableHeaderToolTip from "../../common/components/TableHeaderToolTip.vue";
function getDefaultFormData() {
    return {
        searchType: "1",
        text: "",
        dateType: "1",
        s_time: billDefaultDate().Start.format('yyyy-MM-dd'),
        e_time: billDefaultDate().End.format('yyyy-MM-dd'),
        status: [
            parseInt(EPurSortingStatus.Bsubmit),
            parseInt(EPurSortingStatus.Sorting),
            parseInt(EPurSortingStatus.Submited)
        ],
        depot_id: null,
        area_ids: "",
        shop_id: "",
        route_ids: []
    };
}
function tidyDepotList(treeData) {
    treeData.forEach(function (item) {
        if (item.organ_id && !item.depot_id) {
            item.isDisabled = true;
            item.depot_id = "organ_id_" + item.organ_id;
            item.depot_name = item.organ_name;
        }
        if (item.children && item.children.length) {
            tidyDepotList(item.children);
        }
    });
}
var PurSorting = (function (_super) {
    __extends(PurSorting, _super);
    function PurSorting() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = getDefaultFormData();
        _this.statusList = [];
        _this.tableData = [];
        _this.selectedData = [];
        _this.is_has_scm_goods = false;
        _this.tableHeight = 0;
        _this.total = 0;
        _this.eBillType = EBillType;
        _this.ePurSortingStatus = EPurSortingStatus;
        _this.dialogVisible = false;
        _this.exportType = "1";
        _this.isMoreSearch = false;
        _this.dateTypeList = [{ name: "制单日期", id: "1" }, { name: "到货日期", id: "2" }];
        _this.depotList = [];
        _this.routeList = [];
        _this.exportDetail = {};
        _this.importTypeList = [
            { id: 1, name: '分拣导出-门店分拣' },
            { id: 2, name: '分拣导出-货品分拣' }
        ];
        _this.importType = 1;
        _this.dialogTableVisible = false;
        _this.importSuccessNum = 0;
        _this.importFailnum = 0;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.failDownLoadUrl = "";
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.errorMsg = "";
        return _this;
    }
    PurSorting.prototype.normalizer = function (id, name) {
        if (id === void 0) { id = "id"; }
        if (name === void 0) { name = "name"; }
        return function (node) { return ({
            id: node[id],
            label: node[name],
            children: node.children,
        }); };
    };
    PurSorting.prototype.created = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.$el && _this.$el.parentElement) {
                _this.tableHeight = _this.$el.parentElement.clientHeight - 135;
            }
        }, 300);
        this.service = PurSortingService.getInstance();
        this.commonService = CommonService.getInstance();
        this.printConfigService = PrintConfigService.getInstance();
        this.homeService = HomeService.getInstance();
    };
    PurSorting.prototype.mounted = function () {
        this.areaShopComp = this.$refs.areaShopRef;
        this.getList();
        this.getStatus();
        this.getOrganDepot();
    };
    PurSorting.prototype.exportAll = function () {
        if (!this.selectedData.length) {
            this.$message.error("请选择单据");
            return;
        }
        this.exportModel();
    };
    PurSorting.prototype.getOrganDepot = function () {
        var _this = this;
        this.commonService.getOrganDepot().then(function (res) {
            if (res.data.data.length) {
                var depot = [res.data.data[0]];
                tidyDepotList(depot);
                _this.depotList = [depot[0]];
            }
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    PurSorting.prototype.getRouteList = function () {
        var _this = this;
        this.homeService.getRouteList().then(function (res) {
            if (res.data.success) {
                _this.routeList = res.data.data || [];
            }
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    PurSorting.prototype.getList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        if (this.isMoreSearch) {
            this.isMoreSearch = false;
        }
        ;
        var areaShopValue = this.areaShopComp.getFormData();
        var params = {
            keyword_type: this.formData.searchType,
            keyword: this.formData.text,
            time_type: this.formData.dateType,
            s_time: this.formData.s_time,
            e_time: this.formData.e_time,
            order_status: this.formData.status.join(","),
            depot_id: this.formData.depot_id,
            area_ids: areaShopValue.area_ids,
            shop_id: areaShopValue.shop_id,
            route_ids: this.formData.route_ids.join(","),
            sort_field: this.order ? this.order[0] : undefined,
            sort_type: this.order ? this.order[1] : undefined,
        };
        Object.assign(params, pager);
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getList(params).then(function (res) {
            var data = res.data.data;
            _.forEach(data, function (item) {
                item.listGoods = [];
                (item.items || []).push({ isBtn: true });
            });
            _this.tableData = data;
            _this.total = res.data.total;
            loadingInstance.close();
            if (params.keyword_type == '1') {
                window._czc.push(["_trackEvent", '分拣任务搜索类型', '分拣任务搜索类型', '按货品搜索']);
            }
            else {
                window._czc.push(["_trackEvent", '分拣任务搜索类型', '分拣任务搜索类型', '按单号搜索']);
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    PurSorting.prototype.pageChange = function (pager) {
        this.getList();
    };
    PurSorting.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (!prop) {
            this.order = null;
        }
        else {
            this.order = [prop, order === 'ascending' ? 'asc' : 'desc'];
        }
        this.getList();
    };
    PurSorting.prototype.getStatus = function () {
        var _this = this;
        this.service.getStatus().then(function (res) {
            if (res.data.success) {
                _this.statusList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    PurSorting.prototype.selectionChange = function (val) {
        this.selectedData = val;
    };
    PurSorting.prototype.searchClick = function () {
        this.$refs.pagination.clear();
        this.getList();
    };
    PurSorting.prototype.reset = function () {
        this.formData = getDefaultFormData();
        this.areaShopComp.resetData();
    };
    PurSorting.prototype.mulSubmit = function () {
        var _this = this;
        if (!this.selectedData.length) {
            this.$message.error("请选择单据");
            return;
        }
        var orderIds = this.getSelectIds();
        var order_id = orderIds.join(",");
        this.$confirm("提交后不可修改，请确认是否继续。", "提示", {}).then(function (res) {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.submit(order_id).then(function (res) {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                    _this.getList();
                }
                else {
                    _this.$message.success("提交成功");
                    _this.$refs.pagination.clear();
                    _this.getList();
                    window._czc.push(["_trackEvent", '分拣任务提交', '分拣任务提交']);
                }
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.message || err.msg);
            });
        }, function () { });
    };
    PurSorting.prototype.mulCancel = function () {
        var _this = this;
        if (!this.selectedData.length) {
            this.$message.error("请选择单据");
            return;
        }
        var orderIds = this.getSelectIds();
        var order_id = orderIds.join(",");
        this.$confirm("废弃后，须重新分单，请确认是否废弃选中的单据。", "提示", {}).then(function (res) {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.cancel(order_id).then(function (res) {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                    _this.getList();
                }
                else {
                    _this.$message.success("废弃成功");
                    _this.$refs.pagination.clear();
                    _this.getList();
                    window._czc.push(["_trackEvent", '分拣任务废弃', '分拣任务废弃']);
                }
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.message || err.msg);
            });
        }, function () { });
    };
    PurSorting.prototype.printData = function () {
        if (!this.selectedData.length) {
            this.$message.error("请选择单据");
            return;
        }
        else if (this.selectedData.length > 1) {
            this.$message.error("只能选择一个单据进行打印");
            return;
        }
        var orderIds = this.getSelectIds();
        var url = "./static/js/print/print2.html";
        url = UrlHelper.addParam(url, 'type', "purSorting");
        url = UrlHelper.addParam(url, 'order_id', orderIds.join(","));
        url = UrlHelper.addParam(url, 'token', this.user.token);
        UrlHelper.windowOpenIntercept(url);
        window._czc.push(["_trackEvent", '分拣任务打印', '分拣任务打印']);
    };
    PurSorting.prototype.labelPrint = function () {
        var _this = this;
        if (!this.selectedData.length) {
            this.$message.error("请选择单据");
            return;
        }
        var orderIds = this.getSelectIds();
        var loadingInstance = Loading.service({ fullscreen: true });
        var businessIds = this.selectedData.map(function (item) { return item.business_id; });
        var supplierTobusinessIds = this.selectedData.map(function (item) { return item.supplier_to_business_id; });
        businessIds = _.uniq(businessIds);
        var params = {
            template_type: 21,
            business_id: businessIds.join(','),
            supplier_to_business_ids: supplierTobusinessIds.join(','),
        };
        this.printConfigService.printVerify(params).then(function (res) {
            loadingInstance.close();
            GlobalVue.$emit('addTab', {
                component: PrintSort,
                title: '分拣标签打印',
                showExist: true,
                name: 'print_sort_purchassorting',
                cprops: {
                    orderIds: orderIds.join(","),
                    type: 3
                },
                callback: function (result) {
                    if (result && result.comp && result.comp.getList) {
                        result.comp.orderIds = orderIds.join(",");
                        result.comp.getList();
                    }
                }
            });
        }, function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    PurSorting.prototype.getExportDetail = function () {
        return this.commonService.getExportDetail({
            template_type: EExportTemplateType.PurSorting
        });
    };
    PurSorting.prototype.exportModel = function () {
        var _this = this;
        if (!this.selectedData.length) {
            this.$message.error("请选择单据");
            return;
        }
        this.getExportDetail().then(function (res) {
            _this.exportDetail = res.data.data;
            var instance = _this.$dialog(ExportResult, {
                data: {
                    exportDetail: _this.exportDetail
                }
            }, {
                title: "导出",
                width: 600,
                height: 400
            }).instance;
            instance.$on("export:ok", function (data) {
                data = JSON.parse(data) || null;
                if (data) {
                    _this.commonService.updateExport({
                        data: JSON.stringify(data.exportDetail),
                        remember: data.remember,
                        template_type: EExportTemplateType.PurSorting
                    }).then(function (res) {
                        if (res.data.success) {
                            _this.exportData();
                        }
                    }, function (err) {
                        _this.$message.error(err.message);
                    }).catch(function (err) {
                        _this.$message.error(err.message);
                    });
                }
            });
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    PurSorting.prototype.exportData = function () {
        var orderIds = this.getSelectIds();
        window._czc.push(["_trackEvent", '分拣任务导出', '分拣任务导出']);
        var url = "supplierclientapi/sorting/export?order_id=" + orderIds.join(",");
        url = UrlHelper.addParam(url, 'token', this.user.token);
        location.href = url;
    };
    PurSorting.prototype.operateCommand = function (command) {
        switch (command) {
            case 1:
                this.printData();
                break;
            case 2:
                if (this.selectedData.length > 1) {
                    this.$message.error("只能选择一个单据进行导出");
                    return true;
                }
                this.exportModel();
                break;
            case 3:
                this.mulCancel();
                break;
            case 4:
                this.importModel();
                break;
            case 5:
                this.exportAll();
                break;
            case 6:
                this.labelPrint();
                break;
        }
    };
    PurSorting.prototype.importModel = function () {
        this.dialogTableVisible = true;
        this.setUploadType('beford');
    };
    PurSorting.prototype.beforeUpload = function (file) {
        var name = file.name.split("."), fileType = name[name.length - 1];
        if (!(fileType && (fileType == "xlsx" || fileType == "xls" || fileType == "csv"))) {
            this.$message.error("文件只能是xlsx或xls");
            return false;
        }
        ;
        if (!this.loadingInstance)
            this.loadingInstance = Loading.service({ fullscreen: true });
    };
    PurSorting.prototype.uploadSuccess = function (response, file, fileList) {
        if (response.success) {
            this.responseSuccess = true;
            var data = response.data;
            this.importSuccessNum = data.success_num;
            this.importFailnum = data.error_num;
            var url = "supplierclientapi/sorting/export_order_error?import_id=" + data.import_id;
            url = UrlHelper.addParam(url, 'token', this.user.token);
            this.failDownLoadUrl = url;
            this.getList();
        }
        else {
            this.responseFail = true;
            this.errorMsg = response.msg || "网络异常，请重新导入";
            this.$message.error(response.msg);
        }
        this.uploadEnd(response);
    };
    PurSorting.prototype.uploadError = function (err, file, fileList) {
        this.responseFail = true;
        this.errorMsg = err.msg || err.message || "网络异常，请重新导入";
        this.uploadEnd();
    };
    PurSorting.prototype.uploadEnd = function (res) {
        if (!res.success && res.code && res.code == 9999) {
            this.responseFail = false;
            this.errorMsg = "";
            this.setUploadType("beford");
        }
        else {
            this.setUploadType("after");
        }
        this.loadingInstance.close();
    };
    PurSorting.prototype.uploadProgress = function (event, file, fileList) {
        this.setUploadType("importing");
    };
    PurSorting.prototype.setUploadType = function (type) {
        this.befordImport = type == 'beford';
        this.importting = type == 'importing';
        this.afterImport = type == 'after';
    };
    PurSorting.prototype.getSelectIds = function () {
        var orderIds = this.selectedData.map(function (item) { return item.order_id; });
        return orderIds;
    };
    PurSorting.prototype.moreSearchComShow = function () {
        this.areaShopComp.getArea();
        if (this.routeList.length === 0) {
            this.getRouteList();
        }
        this.isMoreSearch = true;
        window._czc.push(["_trackEvent", '分拣任务高级查询', '高级查询展开']);
    };
    PurSorting.prototype.moreSearchComHide = function () {
        this.isMoreSearch = false;
        window._czc.push(["_trackEvent", '分拣任务高级查询', '高级查询收起']);
    };
    PurSorting.prototype.lookDetail = function (row) {
        toDetail(EBillType.PurSorting, row.order_id, this);
    };
    PurSorting.prototype.edit = function (row) {
        GlobalVue.$emit('addTab', {
            component: Add,
            opener: this,
            title: '修改分拣单',
            showExist: true,
            name: 'pursorting-edit' + row.order_id,
            cprops: {
                orderid: row.order_id
            }
        });
    };
    PurSorting.prototype.expandChange = function (row, expandedRows) {
        var _this = this;
        if (expandedRows.length == 0) {
            return;
        }
        var params = {
            order_id: row.order_id
        };
        var index = this.tableData.indexOf(row);
        this.service.getListGoods(params).then(function (res) {
            var listGoods = res.data.data;
            listGoods.push({ isBtn: true });
            _this.is_has_scm_goods = res.data.is_has_scm_goods === 1 ? true : false;
            GlobalVue.$set(_this.tableData[index], 'listGoods', listGoods);
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    PurSorting = __decorate([
        Component({
            components: {
                'pagination': Pagination,
                "areaShop": AreaShop,
                TableHeaderToolTip: TableHeaderToolTip
            },
            methods: {
                renderHeader: function (h, _a) {
                    var column = _a.column, $index = _a.$index;
                    return this.$createElement('TableHeaderToolTip', {
                        props: {
                            content: "销售系数*订货合计",
                            placement: "bottom"
                        }
                    }, '待领货');
                },
            },
            computed: __assign({}, mapGetters({
                "user": "user",
                "serviceData": 'serviceData',
                "serviceDataList": 'serviceDataList'
            }), { getPlaceholder: function () {
                    if (this.formData.searchType == 1) {
                        return '请输入货品名称关键字查询';
                    }
                    if (this.formData.searchType == 2) {
                        return '请输入分拣单号关键字查询';
                    }
                    if (this.formData.searchType == 3) {
                        return '请输入订货单号关键字查询';
                    }
                } })
        })
    ], PurSorting);
    return PurSorting;
}(Vue));
export default PurSorting;
